import React, { useEffect, useState } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { ParticipantItem } from './ParticipantCard';
import { errorMessage } from '../participantApi';
import { GradientButton, INK, MUTED } from '../ui';

// Выгрузка контактов в Excel: имя + все поля анкеты + контакты (без фото).
const exportToExcel = async (items, fileName) => {
  const XLSX = await import('xlsx');
  const columns = [];
  const addColumn = f => {
    if (!columns.find(c => c.key === f.key)) columns.push({ key: f.key, label: f.label });
  };
  items.forEach(card => {
    (card.fields || []).forEach(addColumn);
    (card.contacts || []).forEach(addColumn);
  });
  const header = ['Имя', ...columns.map(c => c.label)];
  const rows = items.map(card => {
    const values = {};
    [...(card.fields || []), ...(card.contacts || [])].forEach(f => {
      values[f.key] = f.value;
    });
    return [card.fullName, ...columns.map(c => values[c.key] || '')];
  });
  const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);
  ws['!cols'] = header.map(h => ({ wch: Math.max(14, Math.min(40, h.length + 4)) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Контакты');
  XLSX.writeFile(wb, fileName);
};

// EV-85: разделы «Запросы» (входящие) и «Контакты» (согласованные) — один компонент, разный источник.
const CardsTab = ({ load, emptyText, hint, countLabel, refreshKey, kinds, contactsOpen, exportFileName, busy, onAccept, onDecline }) => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    load()
      .then(({ data }) => !cancelled && (setItems(data), setError(null)))
      .catch(err => !cancelled && setError(errorMessage(err)));
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  if (error) return <Alert severity='error'>{error}</Alert>;
  if (!items) return null;

  return (
    <Box>
      {items.length > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {countLabel && (
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: INK }}>
                {countLabel}: {items.length}
              </Typography>
            )}
            {hint && <Typography sx={{ color: MUTED, fontSize: 13, lineHeight: 1.4 }}>{hint}</Typography>}
          </Box>
          {exportFileName && (
            <GradientButton
              startIcon={<FileDownloadOutlinedIcon />}
              onClick={() => exportToExcel(items, exportFileName)}
              sx={{ flexShrink: 0, height: 40, px: 2, whiteSpace: 'nowrap' }}
            >
              Скачать Excel
            </GradientButton>
          )}
        </Box>
      )}
      {items.length === 0 && (
        <Typography sx={{ color: MUTED, textAlign: 'center', mt: 4 }}>{emptyText}</Typography>
      )}
      <Box sx={{ display: 'grid', gap: 1 }}>
        {items.map(card => (
          <ParticipantItem
            key={card.visitorId}
            card={card}
            kinds={kinds}
            busy={busy}
            contactsOpen={contactsOpen}
            onAccept={onAccept}
            onDecline={onDecline}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CardsTab;
